module.exports = __webpack_public_path__ + "img/230.ecb7e2cb.jpg";